// ---- Autosave visível + autoria (§17-19 da spec de Ambientes e Peças) ----
let _autosalvandoPedido=false;
function atualizarStatusAutosave(estado){
  const el=document.getElementById('orc-autosave-status');if(!el)return;
  const textos={
    salvando:'<i class="ti ti-loader-2"></i> Salvando...',
    salvo:'<i class="ti ti-circle-check" style="color:var(--green)"></i> Salvamento automático ativo',
    erro:'<i class="ti ti-alert-triangle" style="color:var(--red)"></i> Não foi possível salvar agora — tentaremos de novo'
  };
  el.innerHTML=textos[estado]||textos.salvo;
  el.dataset.estado=estado;
}
function relativoTempo(data){
  if(!data)return'';
  const d=data?.toDate?data.toDate():new Date(data);
  if(Number.isNaN(d.getTime()))return'';
  const seg=Math.floor((Date.now()-d.getTime())/1000);
  if(seg<10)return'agora mesmo';
  if(seg<60)return'há poucos segundos';
  if(seg<3600)return`há ${Math.floor(seg/60)} min`;
  if(seg<86400)return`há ${Math.floor(seg/3600)} h`;
  return d.toLocaleString('pt-BR',{dateStyle:'short',timeStyle:'short'});
}
// "Última atualização por X — Cargo · há poucos segundos" (§19). updatedBy/
// updatedAt já são gravados automaticamente por DB.set() — aqui só exibimos.
// Sem lookup assíncrono de outro usuário: se quem salvou por último não for quem
// está com o modal aberto agora, mostramos o identificador gravado (e-mail),
// sem inventar cargo que não temos como confirmar de forma síncrona.
function renderAutoriaUltimaAlteracao(pedido){
  const el=document.getElementById('orc-autoria-info');const avatarEl=document.getElementById('orc-autoria-avatar');
  if(!el)return;
  if(!pedido?.updatedAt){el.innerHTML='';if(avatarEl)avatarEl.innerHTML='';return}
  const authUser=typeof firebase?.auth==='function'?firebase.auth().currentUser:null;
  const souEu=!!pedido.updatedBy&&(pedido.updatedBy===authUser?.email||pedido.updatedBy===authUser?.uid);
  const role=window.MarmoriaSaaS?.state.membership?.role;
  const roleLabel=souEu&&role?(window.MarmoriaOrganizationAdmin?.roleLabels?.[role]||''):'';
  const nome=souEu?(authUser?.displayName||_meuPerfil?.fullName||'Você'):(pedido.updatedBy||'—');
  el.innerHTML=`Última atualização por <strong style="color:var(--text)">${escapeHtml(nome)}</strong>${roleLabel?' — '+escapeHtml(roleLabel):''}<br><span style="color:var(--muted)">${escapeHtml(relativoTempo(pedido.updatedAt))}</span>`;
  if(avatarEl)avatarEl.innerHTML=souEu?perfilAvatarHtml(_meuPerfil||{fullName:nome,authPhotoUrl:authUser?.photoURL||''},nome):perfilAvatarHtml({fullName:nome},nome);
}
// Máquina de estado idle → saving → dirty-during-save (revisão técnica do Daniel,
// 2026-08-12): um booleano único de "estou salvando" perdia edições feitas
// enquanto um save estava em voo — se o usuário mudasse outro campo durante o
// `await`, essa mudança só seria pega no PRÓXIMO disparo por acaso, não por
// garantia. Agora: se chega um pedido de salvar enquanto já há um em andamento,
// fica marcado "dirty-during-save" e o próprio save em andamento, ao terminar,
// reagenda automaticamente — nenhuma edição feita durante o save fica perdida.
let _pedidoDirty=false;
let _pedidoSaveState='idle'; // 'idle' | 'saving' | 'dirty-during-save'
async function salvarPedidoAutomaticamente(){
  if(_pedidoSaveState==='saving'){_pedidoSaveState='dirty-during-save';return}
  if(!_pedidoDirty)return;
  const pidEl=document.getElementById('pid');if(!pidEl)return; // modal fechado
  _pedidoSaveState='saving';
  _pedidoDirty=false;
  atualizarStatusAutosave('salvando');
  try{
    const obj=await montarESalvarPedidoObj({skipValidation:true});
    if(obj){atualizarStatusAutosave('salvo');renderAutoriaUltimaAlteracao(obj);}
    else{atualizarStatusAutosave('erro');_pedidoDirty=true;}
  }catch(e){
    console.warn('[autosave] falha ao salvar pedido automaticamente',e);
    atualizarStatusAutosave('erro');
    _pedidoDirty=true; // falhou (ex.: rede caiu): continua sujo, tenta de novo depois
  }finally{
    const precisaSalvarDeNovo=_pedidoSaveState==='dirty-during-save'||_pedidoDirty;
    _pedidoSaveState='idle';
    if(precisaSalvarDeNovo)_autosalvarPedidoDebounced();
  }
}
const _autosalvarPedidoDebounced=debounce(salvarPedidoAutomaticamente,1200);
// Separação pedida na revisão: marcar "há mudança pendente" e "hora de persistir"
// são responsabilidades diferentes. O debounce resolve frequência; esta função
// resolve semântica (não salva nada aqui, só sinaliza e agenda) — abre espaço
// para no futuro recusar autosave quando o estado do formulário for inválido,
// sem precisar mexer nos ~15 pontos de chamada que já usam _dispararAutosavePedido.
function marcarPedidoComoAlterado(){
  const pidEl=document.getElementById('pid');if(!pidEl)return;
  const eid=pidEl.value,cliente=document.getElementById('p-cliente')?.value.trim();
  if(!eid&&!cliente)return; // nada digno de salvar ainda
  _pedidoDirty=true;
  _autosalvarPedidoDebounced();
}
function _dispararAutosavePedido(){marcarPedidoComoAlterado();}
function _orcAutosaveInputHandler(event){
  if(!['INPUT','SELECT','TEXTAREA'].includes(event.target?.tagName))return;
  _dispararAutosavePedido();
}
document.getElementById('orc-piece-panel')?.addEventListener('input',_orcAutosaveInputHandler);
document.getElementById('orc-piece-panel')?.addEventListener('change',_orcAutosaveInputHandler);
document.getElementById('orcamento-ambientes')?.addEventListener('input',_orcAutosaveInputHandler);
document.getElementById('orcamento-ambientes')?.addEventListener('change',_orcAutosaveInputHandler);
document.getElementById('p-itens-container')?.addEventListener('input',_orcAutosaveInputHandler);
document.getElementById('p-itens-container')?.addEventListener('change',_orcAutosaveInputHandler);
// ---- Histórico de edições campo a campo (§20-21) ----
// montarESalvarPedidoObj audita o pedido como um todo, mas remove itens/custos do
// snapshot (evita payload gigante em todo save comercial) — por isso mudanças de
// ambientes/peças nunca apareciam no histórico. Esta função gera uma auditoria
// SEPARADA, só com o resumo legível campo a campo, reaproveitando auditar()/
// auditDiffRows()/abrirHistoricoDoRegistro() já existentes — sem modal novo.
const CAMPOS_DIFF_PECA=[
  {campo:'desc',label:'nome'},{campo:'material',label:'material'},
  {campo:'comp',label:'comprimento',unidade:' cm'},{campo:'larg',label:'largura',unidade:' cm'},
  {campo:'qtd',label:'quantidade'},{campo:'espessura',label:'espessura'},
  {campo:'acabamento',label:'acabamento'},{campo:'borda',label:'borda'}
];
function resumirDiffItensPecaUnica(antesIt,it){
  // Revisão técnica de 2026-08-12: mudança de it.ambiente NÃO é mais diffada
  // aqui. Um rename em massa (renomearPedidoAmbiente) muda o campo ambiente de
  // toda peça do ambiente de uma vez, e diffar por peça gerava N linhas ruidosas
  // ("moveu X para Y", "moveu Z para Y"...) para uma única ação de renomear. A
  // movimentação REAL de uma peça entre ambientes (drag na peça, não no chip do
  // ambiente) é registrada na origem via registrarEventoAmbiente em pedItemDrop;
  // renomear/criar/remover ambiente também via eventos próprios — ver
  // auditarAlteracoesAmbientesPecas.
  const nome=it.desc||'Peça sem nome',linhas=[];
  CAMPOS_DIFF_PECA.forEach(({campo,label,unidade})=>{
    const a=antesIt[campo],d=it[campo];
    if(String(a??'')!==String(d??''))linhas.push(`alterou ${label} de "${nome}" de ${a||'—'}${unidade&&a?unidade:''} para ${d||'—'}${unidade&&d?unidade:''}`);
  });
  const subAntes=(antesIt.pecas||[]).length,subDepois=(it.pecas||[]).length;
  if(subDepois>subAntes)linhas.push(`adicionou ${subDepois-subAntes} sub-peça(s) em "${nome}"`);
  else if(subDepois<subAntes)linhas.push(`removeu ${subAntes-subDepois} sub-peça(s) de "${nome}"`);
  const acabDepois=it.acabamentosExtras||[],acabAntes=antesIt.acabamentosExtras||[];
  acabDepois.forEach(ex=>{if(!acabAntes.some(e=>e.catalogoId===ex.catalogoId))linhas.push(`adicionou o acabamento "${ex.nome||'—'}" em "${nome}"`);});
  acabAntes.forEach(ex=>{if(!acabDepois.some(e=>e.catalogoId===ex.catalogoId))linhas.push(`removeu o acabamento "${ex.nome||'—'}" de "${nome}"`);});
  return linhas;
}
function resumirDiffItensPedido(itensAntes,itensDepois){
  const antes=itensAntes||[],depois=itensDepois||[];
  const antesPorId=new Map(antes.map(it=>[it.id,it])),depoisPorId=new Map(depois.map(it=>[it.id,it]));
  const linhas=[];
  depois.forEach(it=>{
    const antesIt=antesPorId.get(it.id);
    if(!antesIt){linhas.push(`adicionou a peça "${it.desc||'Peça sem nome'}"`);return}
    linhas.push(...resumirDiffItensPecaUnica(antesIt,it));
  });
  antes.forEach(it=>{if(!depoisPorId.has(it.id))linhas.push(`removeu a peça "${it.desc||'Peça sem nome'}"`);});
  return linhas;
}
// Fila de eventos de ambiente (criar/renomear/remover/mover peça) — registrados
// na ORIGEM da ação (addPedidoAmbiente, renomearPedidoAmbiente,
// removerPedidoAmbiente, pedItemDrop), não inferidos por diff depois. Mais
// preciso que comparar itens antes/depois (que não sabe distinguir "renomeei o
// ambiente" de "movi a peça pra outro ambiente" — são ações diferentes com
// origem diferente no código). Esvaziada após cada auditoria bem-sucedida.
let _pedAmbienteEventos=[];
function registrarEventoAmbiente(mensagem){_pedAmbienteEventos.push(mensagem);}
async function auditarAlteracoesAmbientesPecas(pedido,antesItens,depoisItens,antesOrdem,depoisOrdem,eventosAmbiente,saveId){
  const eventos=eventosAmbiente||[];
  const linhas=[...eventos,...resumirDiffItensPedido(antesItens,depoisItens)];
  if(!eventos.length&&JSON.stringify(antesOrdem||[])!==JSON.stringify(depoisOrdem||[]))linhas.push('reorganizou a ordem dos ambientes');
  if(!linhas.length)return;
  await auditar('editou','Ambientes e peças',`Pedido #${pedido.num}: ${linhas.join('; ')}`,null,{id:pedido.id,resumo:linhas.join('; ')},saveId?{saveId}:null);
}
// ---- Histórico de versões do orçamento (voltar a um ponto anterior) ----
// Cada salvamento (autosave ou manual) já grava um evento de auditoria "Pedido"
// com o estado COMPLETO anterior em `antes` (ver montarESalvarPedidoObj) — é
// material suficiente para restaurar. O `saveId` liga esse evento ao evento
// "Ambientes e peças" do mesmo save, cujo texto já descreve a mudança peça a
// peça. Cada entrada da lista = um "conjunto de alterações" (o autosave já
// agrupa edições próximas no tempo em um único save), não uma alteração por tecla.
const CAMPOS_DIFF_PEDIDO_TOPO=[
  {campo:'valor',label:'valor do orçamento',fmt:v=>fmt(parseFloat(v)||0)},
  {campo:'status',label:'status',fmt:v=>SL[v]||v||'—'}
];
function resumirDiffPedidoTopo(antes,depois){
  if(!antes)return[];
  const linhas=[];
  CAMPOS_DIFF_PEDIDO_TOPO.forEach(({campo,label,fmt:f})=>{
    const a=antes[campo],d=depois?.[campo];
    if(String(a??'')!==String(d??''))linhas.push(`alterou ${label} de ${f?f(a):(a||'—')} para ${f?f(d):(d||'—')}`);
  });
  return linhas;
}
function historicoVersoesPedido(pedidoId){
  if(!pedidoId)return[];
  const eventos=(CACHE.auditoria||[]).filter(a=>a.registroId===pedidoId);
  const saves=eventos.filter(a=>a.modulo==='Pedido'&&['editou','criou'].includes(a.acao)).slice().sort((a,b)=>dataAuditoriaMs(a)-dataAuditoriaMs(b));
  if(!saves.length)return[];
  const resumosPecas=new Map();
  eventos.filter(a=>a.modulo==='Ambientes e peças'&&a.saveId).forEach(a=>resumosPecas.set(a.saveId,a.descricao));
  const atual=(DB.get('pedidos')||[]).find(p=>p.id===pedidoId)||null;
  return saves.map((ev,idx)=>{
    const antes=parseAuditObj(ev.antes);
    const refDepois=idx<saves.length-1?parseAuditObj(saves[idx+1].antes):atual;
    const linhas=resumirDiffPedidoTopo(antes,refDepois||{});
    const resumoPecas=ev.saveId?resumosPecas.get(ev.saveId):null;
    if(resumoPecas)linhas.push(...String(resumoPecas).replace(/^Pedido #\d+:\s*/,'').split('; ').filter(Boolean));
    return{id:ev.id,timestamp:ev.timestamp,usuario:ev.usuario,resumo:linhas.length?linhas:['Salvou sem alterações de campos identificadas'],valida:!!antes?.id};
  }).reverse();
}
function renderHistoricoVersoesPedido(){
  const el=document.getElementById('historico-pedido-lista');if(!el)return;
  const id=document.getElementById('pid')?.value;
  const versoes=historicoVersoesPedido(id);
  if(!versoes.length){el.innerHTML='<div class="empty">Ainda não há versões salvas deste orçamento.</div>';return}
  el.innerHTML=versoes.map(v=>`<div style="border:1px solid var(--border);border-radius:9px;padding:10px 12px">
    <div style="display:flex;justify-content:space-between;gap:10px;align-items:start">
      <div><strong style="font-size:12.5px">${escapeHtml(fmtTs(v.timestamp))}</strong><div style="font-size:11px;color:var(--muted)">👤 ${escapeHtml(v.usuario||'—')}</div></div>
      <button class="btn btn-ghost btn-sm" ${v.valida?'':'disabled'} onclick="restaurarVersaoPedido('${v.id}')" title="${v.valida?'Voltar o orçamento para como estava antes desta alteração':'Sem dados completos para restaurar esta versão'}">↺ Restaurar</button>
    </div>
    <ul style="margin:8px 0 0 18px;padding:0;font-size:12px">${v.resumo.map(l=>`<li>${escapeHtml(l)}</li>`).join('')}</ul>
  </div>`).join('');
}
function abrirHistoricoEdicoesPedido(){
  const id=document.getElementById('pid')?.value;
  if(!id){toast('Salve o pedido pelo menos uma vez para ver o histórico.','info');return}
  renderHistoricoVersoesPedido();
  openModal('modal-historico-pedido');
}
async function restaurarVersaoPedido(auditId){
  const evento=(CACHE.auditoria||[]).find(a=>a.id===auditId);
  if(!evento){toast('Versão não encontrada no histórico.','error');return}
  const snapshot=parseAuditObj(evento.antes);
  if(!snapshot?.id){toast('Esta versão não tem dados completos para restaurar.','error');return}
  const quando=fmtTs(evento.timestamp);
  if(!await uiConfirm({tone:'warning',eyebrow:'Histórico de versões',title:'Restaurar esta versão?',message:`O orçamento volta ao estado de ${quando}, antes desta alteração.`,impact:'Nada é apagado: os dados atuais continuam no histórico e você pode restaurar a versão mais recente de novo se precisar.',confirmLabel:'Restaurar esta versão'}))return;
  const lista=[...DB.get('pedidos')],i=lista.findIndex(p=>p.id===snapshot.id);
  if(i<0){toast('Orçamento não encontrado para restaurar.','error');return}
  const atual=lista[i];
  const restaurado={...snapshot,id:atual.id,num:atual.num,createdAt:atual.createdAt,updatedAt:new Date().toISOString()};
  lista[i]=restaurado;
  await DB.set('pedidos',lista);
  await auditar('editou','Pedido',`Restaurou o orçamento #${restaurado.num} para o estado de ${quando}`,atual,{...restaurado,custos:undefined,itens:undefined});
  toast('Versão restaurada ✓');
  closeModal('modal-historico-pedido');
  openModal('modal-pedido',restaurado);
  renderOrcamentos();renderPedidos();
}
function renderListaPecasAmbiente(){
  const el=document.getElementById('orc-lista-pecas');if(!el)return;
  const nomes=nomesAmbientesAtuais();
  const ambienteLabel=document.getElementById('orc-ambiente-ativo-label');
  if(ambienteLabel)ambienteLabel.textContent=_pedAmbAtivo!=null?(_pedAmbAtivo||'Geral'):'—';
  if(!nomes.length){
    el.innerHTML='<div class="orc-panel-empty">Comece criando o primeiro ambiente do orçamento.</div><div class="orc-sidebar-actions"><button class="btn btn-primary btn-sm" data-action="novo-ambiente">+ Novo ambiente</button></div>';
    return;
  }
  if(_pedAmbAtivo==null){el.innerHTML='<div class="orc-panel-empty">Selecione um ambiente para ver as peças.</div>';return;}
  const itens=pecasDoAmbiente(_pedAmbAtivo);
  if(!itens.length){
    el.innerHTML='<div class="orc-panel-empty">Este ambiente ainda não possui peças.</div><div class="orc-sidebar-actions"><button class="btn btn-primary btn-sm" data-action="nova-peca">+ Adicionar primeira peça</button><button class="btn btn-ghost btn-sm" data-action="novo-ambiente">+ Novo ambiente</button></div>';
    return;
  }
  const ordenadas=[...itens].sort((a,b)=>(b.it.principal?1:0)-(a.it.principal?1:0));
  el.innerHTML=ordenadas.map(({it,i})=>{
    const m2=it._m2||calcItemM2Total(it);
    const total=it._subtotal||0;
    const ativo=i===_pedItemAtivo;
    const aprovada=it.statusMedida==='aprovada';
    return `<div class="orc-piece-card${ativo?' active':''}" data-peca-index="${i}" role="button" tabindex="0">
      <div class="orc-piece-thumb" id="orc-sidebar-material-image-${i}"><i class="ti ti-dimensions"></i></div>
      <div class="orc-piece-info">
        <div style="font-weight:700;font-size:13px">${escapeHtml(it.desc||'Peça sem nome')} ${it.principal?'<span class="badge b-aprovado" style="font-size:9px">Peça principal</span>':''}</div>
        <div style="font-size:11.5px;color:var(--muted)">${escapeHtml(it.material||'Sem material')} · ${it.comp||0} × ${it.larg||0} cm · Qtd. ${it.qtd||1}</div>
        <div style="font-size:11px;color:${aprovada?'var(--green)':'var(--muted)'}">${aprovada?'✓ ':''}${STATUS_MEDIDA_ITEM[it.statusMedida]||'Estimada'} · ${m2.toFixed(3)} m²</div>
        <div class="orc-piece-actions"><span class="orc-piece-total">${fmt(total)}</span><button class="btn btn-ghost btn-sm" style="padding:2px 5px" data-action="duplicar-peca" data-peca-index="${i}" title="Duplicar peça (cópia independente)">⧉</button><button class="btn btn-ghost btn-sm" style="padding:2px 5px" data-action="excluir-peca" data-peca-index="${i}" title="Excluir peça">🗑</button></div>
      </div>
    </div>`;
  }).join('')+`<div class="orc-sidebar-actions"><button class="btn btn-primary btn-sm" data-action="nova-peca">+ Adicionar peça</button><button class="btn btn-ghost btn-sm" data-action="novo-ambiente">+ Novo ambiente</button></div>`;
  ordenadas.forEach(({it,i})=>{
    const imageContext=orcMaterialImageContext(it);
    const selectedImage=it.materialImageChoiceId==='none'?null:imageContext?.gallery.find(image=>image.id===(it.materialImageChoiceId||imageContext?.selected?.id))||imageContext?.selected;
    if(selectedImage)materialImageDisplayUrl(selectedImage).then(url=>{
      const thumb=document.getElementById(`orc-sidebar-material-image-${i}`);
      if(url&&thumb)thumb.innerHTML=`<img src="${escapeHtml(url)}" alt="${escapeHtml(it.material||'Material')}" loading="lazy" decoding="async">`;
    });
  });
}
function selecionarAmbiente(nome){_pedAmbAtivo=nome;_pedItemAtivo=null;renderChipsAmbientes();renderListaPecasAmbiente();renderPainelPeca();}
function selecionarPeca(i){_pedItemAtivo=i;renderPainelPeca();renderListaPecasAmbiente();}
function fecharPainelPeca(){_pedItemAtivo=null;renderPainelPeca();renderListaPecasAmbiente();}
function renderPainelPeca(){
  const el=document.getElementById('orc-piece-panel');if(!el)return;
  const it=_pedItemAtivo!=null?_pedItens[_pedItemAtivo]:null;
  const sidebarPreench=document.getElementById('orc-sidebar-preenchimento');
  if(!it){el.classList.remove('is-open');el.innerHTML='<div class="orc-panel-empty">Selecione uma peça para visualizar e editar seus detalhes.</div>';if(sidebarPreench)sidebarPreench.innerHTML='';return;}
  el.classList.add('is-open');
  const i=_pedItemAtivo;
  const m2=it._m2||calcItemM2Total(it);
  const total=it._subtotal||0;
  const matEst=precoMaterialEstimado(it.material);
  el.innerHTML=`
    <div class="orc-piece-header">
      <div style="flex:1">
        <input class="si" style="font-weight:700;padding:5px 8px;margin-bottom:4px" value="${escapeHtml(it.desc||'')}" placeholder="Nome da peça" list="pecas-datalist" oninput="_pedItens[${i}].desc=this.value" onchange="renderPedItens()">
        ${it.principal?'<span class="badge b-aprovado" style="font-size:9px">Peça principal</span>':`<a href="#" onclick="definirPecaPrincipal(${i});return false" style="font-size:11px;color:var(--accent)">Definir como principal</a>`}
      </div>
      <button class="btn btn-ghost btn-sm" onclick="fecharPainelPeca()" title="Fechar">×</button>
    </div>
    <div class="orc-piece-top-grid">
      <div class="form-grid orc-piece-fields" id="orc-piece-fields-wrap-${i}" style="margin-bottom:0">
        <div class="field" style="margin:0"><label>Comprimento (cm)</label><input type="text" inputmode="decimal" class="si" value="${escapeHtml(String(it.comp||''))}" oninput="_pedItens[${i}].comp=this.value;calcItensTotal();atualizarDesenhoPeca(${i})" onchange="atualizarOrcamentoUI()"></div>
        <div class="field" style="margin:0"><label>Largura (cm)</label><input type="text" inputmode="decimal" class="si" value="${escapeHtml(String(it.larg||''))}" oninput="_pedItens[${i}].larg=this.value;calcItensTotal();atualizarDesenhoPeca(${i})" onchange="atualizarOrcamentoUI()"></div>
        <div class="field" style="margin:0"><label>Qtd</label><input type="number" min="1" class="si" value="${it.qtd||1}" oninput="_pedItens[${i}].qtd=this.value;calcItensTotal()" onchange="atualizarOrcamentoUI()"></div>
        <div class="field" style="margin:0"><label>Espessura</label><select class="si" onchange="_pedItens[${i}].espessura=this.value;calcItensTotal();atualizarOrcamentoUI();atualizarDesenhoPeca(${i})">${orcSelectOpcoes(ESPESSURAS_ORC,it.espessura||'2 cm')}</select></div>
        <div class="field" style="margin:0"><label>Acabamento</label><select class="si" onchange="_pedItens[${i}].acabamento=this.value">${orcSelectOpcoes(ACABAMENTOS_ORC,it.acabamento||'Polido')}</select></div>
        <div class="field" style="margin:0"><label>Borda</label><select class="si" onchange="_pedItens[${i}].borda=this.value">${orcSelectOpcoes(BORDAS_ORC,it.borda||'Reta')}</select></div>
      </div>
      <div class="orc-piece-desenho-box">
        <div style="font-size:10.5px;text-transform:uppercase;letter-spacing:.06em;color:var(--muted);margin-bottom:6px;text-align:left" title="Representação proporcional orientativa: comprimento, largura e espessura respondem aos campos em tempo real.">Desenho <i class="ti ti-info-circle"></i></div>
        <div id="orc-item-desenho-${i}">${gerarDesenhoPecaSimples({comprimento:it.comp,largura:it.larg,espessura:it.espessura})}</div>
      </div>
    </div>
    <div class="orc-material-row">
      <div class="orc-material-thumb" id="orc-item-material-image-${i}"><i class="ti ti-photo"></i></div>
      <div class="field" style="margin:0;min-width:0">
        <label>Material</label>
        <input class="si" value="${escapeHtml(it.material||'')}" placeholder="São Gabriel, Carrara..." list="materiais-pedido-datalist" onchange="aplicarCatalogoItem(${i},this.value)">
        <div style="font-size:11px;color:var(--muted);margin-top:4px">${matEst.valor>0?`Estimado · ${fmt(matEst.valor)} / m²`:'Sem preço cadastrado'}</div>
      </div>
      <button type="button" class="btn btn-ghost btn-sm" onclick="abrirSeletorMaterial(${i})">Selecionar material</button>
    </div>
      ${orcMaterialImageEditor(it,i)}
      ${renderPecasHTML(it,i)}
    <div class="orc-benefit-shell">
      <div class="orc-section-heading"><span>Acabamentos e detalhes especiais</span><button type="button" class="btn btn-ghost btn-sm" onclick="document.getElementById('orc-item-acabamento-select-${i}')?.focus()">+ Adicionar beneficiamento</button></div>
      <div class="orc-benefit-tabs" aria-label="Categorias de beneficiamento">
        ${(window.MasterBenefitCatalog?.categories||[]).map(cat=>`<button type="button" class="btn ${_orcBeneficioCategoriaAtiva===cat.id?'':'btn-ghost'} btn-sm" aria-pressed="${_orcBeneficioCategoriaAtiva===cat.id}" onclick="setOrcBeneficioCategoria('${cat.id}')">${escapeHtml(cat.label)}</button>`).join('')}
      </div>
      <div class="orc-benefit-editor">
        <div class="orc-benefit-entry-fields">
          <div class="field" style="margin:0"><label>Tipo de beneficiamento</label><select class="si" id="orc-item-acabamento-select-${i}" onchange="acabamentoAtualizarPreviewSelecao(${i})">${acabamentosOpcoesSelect(_orcBeneficioCategoriaAtiva)}</select></div>
          <div class="field" style="margin:0"><label>Preço do serviço</label><div class="si-money"><span>R$</span><input class="si" id="orc-item-acabamento-preco-${i}" type="text" inputmode="decimal" placeholder="0,00"></div><small id="orc-item-acabamento-unidade-${i}" style="color:var(--muted)">Informe após escolher</small></div>
          <button type="button" class="btn btn-ghost btn-sm" onclick="adicionarAcabamentoExtra(${i},document.getElementById('orc-item-acabamento-select-${i}').value,document.getElementById('orc-item-acabamento-preco-${i}').value);acabamentoAtualizarPreviewSelecao(${i})">+ Adicionar</button>
        </div>
        <div class="orc-benefit-preview"><div style="font-size:10px;color:var(--muted);font-weight:700;margin-bottom:6px">Imagem de referência <i class="ti ti-info-circle"></i></div><div id="orc-item-acabamento-preview-${i}"></div></div>
      </div>
      <div id="orc-item-acabamentos-${i}" style="margin-top:12px">${renderAcabamentosExtrasLista(it,i)}</div>
    </div>
    <div class="orc-cost-shell">
      <div class="orc-cost-head"><div style="font-size:10.5px;text-transform:uppercase;letter-spacing:.06em;color:var(--muted);font-weight:800">Cálculo de custos</div>
        <a href="#" onclick="_pedItens[${i}]._mostrarCustosInternos=!_pedItens[${i}]._mostrarCustosInternos;renderPainelPeca();return false" style="font-size:11px;color:var(--accent)">Custos internos — avançado ${it._mostrarCustosInternos?'▲':'▼'}</a>
      </div>
      <div class="orc-cost-grid">
        <div class="orc-cost-item"><div style="color:var(--muted);font-size:9.5px">Material consumido</div><div style="font-size:9.5px;color:var(--muted)">${m2.toFixed(3)} m²</div><div style="font-weight:800">${fmt(it._matConsumido||0)}</div></div>
        <div class="orc-cost-item"><div style="color:var(--muted);font-size:9.5px">Fabricação padrão</div><div style="font-weight:800">${fmt(it._fabricacaoPadrao||0)}</div></div>
        <div class="orc-cost-item"><div style="color:var(--muted);font-size:9.5px">Material adicional</div><div style="font-weight:800">${fmt(it._materialAdicional||0)}</div></div>
        <div class="orc-cost-item"><div style="color:var(--muted);font-size:9.5px">Beneficiamentos especiais</div><div style="font-size:9.5px;color:var(--muted)">${(it.acabamentosExtras||[]).length} item(ns)</div><div style="font-weight:800">${fmt(it._beneficiamentos||0)}</div></div>
        <div class="orc-cost-item"><div style="color:var(--muted);font-size:9.5px">Total da peça</div><div style="font-weight:800;color:var(--accent)">${fmt(total)} <i class="ti ti-info-circle"></i></div></div>
      </div>
      <div style="margin-top:8px">
        ${it._mostrarCustosInternos?`<div class="form-grid" style="grid-template-columns:repeat(2,1fr);margin-top:8px">
          <div class="field" style="margin:0"><label>Material R$/m² 🔒</label><input class="si" type="text" inputmode="decimal" value="${it.custoMaterialM2||0}" oninput="_pedItens[${i}].custoMaterialM2=this.value;calcItensTotal();renderPainelPeca()"></div>
          <div class="field" style="margin:0"><label>Fábrica R$/m² 🔒</label><input class="si" type="text" inputmode="decimal" value="${it.custoFabricaM2||0}" oninput="_pedItens[${i}].custoFabricaM2=this.value;calcItensTotal();renderPainelPeca()"></div>
          <div class="field" style="margin:0"><label>MO adicional 🔒</label><input class="si" type="text" inputmode="decimal" value="${it.mo||''}" oninput="_pedItens[${i}].mo=this.value;calcItensTotal();renderPainelPeca()"></div>
        </div>`:''}
      </div>
      <div class="orc-cost-note"><i class="ti ti-info-circle" style="color:var(--accent);font-size:16px"></i><span>Valores estimados com base nas medidas informadas.<br>Números derivados da composição da peça para máxima precisão na produção e precificação.</span></div>
    </div>
  `;
  if(sidebarPreench)sidebarPreench.innerHTML=renderPainelPreenchimentoPeca(it,i);
  const imageContext=orcMaterialImageContext(it);
  const selectedImage=it.materialImageChoiceId==='none'?null:imageContext?.gallery.find(image=>image.id===(it.materialImageChoiceId||imageContext?.selected?.id))||imageContext?.selected;
  if(selectedImage)materialImageDisplayUrl(selectedImage).then(url=>{
    const thumb=document.getElementById(`orc-item-material-image-${i}`);
    if(url&&thumb)thumb.innerHTML=`<img src="${escapeHtml(url)}" alt="${escapeHtml(selectedImage.type||'Imagem do material')}" loading="lazy" decoding="async">`;
  });
}
async function excluirPecaAtiva(i){
  const it=_pedItens[i];if(!it)return;
  if((it.pecas||[]).length){
    if(!await uiConfirm({tone:'danger',eyebrow:'Peça',title:'Excluir esta peça?',message:it.desc||'Peça sem nome',impact:`Esta peça possui ${it.pecas.length} sub-peça(s) que também serão excluídas.`,confirmLabel:'Excluir peça'}))return;
  }
  _pedItens.splice(i,1);
  if(_pedItemAtivo===i)_pedItemAtivo=null;
  else if(_pedItemAtivo>i)_pedItemAtivo--;
  renderPedItens();
  _dispararAutosavePedido();
}
function _orcAmbientesClickHandler(event){
  const acao=event.target.closest('[data-action]');
  const ambiente=event.target.closest('[data-ambiente]');
  const peca=event.target.closest('[data-peca-index]');
  if(acao){executarAcaoOrcamento(acao.dataset.action,acao.dataset.ambiente,acao.dataset.pecaIndex!=null?Number(acao.dataset.pecaIndex):null);return;}
  if(ambiente){selecionarAmbiente(ambiente.dataset.ambiente);return;}
  if(peca){selecionarPeca(Number(peca.dataset.pecaIndex));}
}
function _orcAmbientesKeydownHandler(event){
  if(event.key!=='Enter'&&event.key!==' ')return;
  const alvo=event.target.closest('[role="button"][data-ambiente],[role="button"][data-action]');
  if(!alvo||event.target!==alvo)return;
  event.preventDefault();
  alvo.click();
}
document.getElementById('orcamento-ambientes')?.addEventListener('click',_orcAmbientesClickHandler);
document.getElementById('orcamento-ambientes')?.addEventListener('keydown',_orcAmbientesKeydownHandler);
function executarAcaoOrcamento(acao,ambiente,pecaIndex){
  if(acao==='novo-ambiente')return addPedidoAmbiente();
  if(acao==='renomear-ambiente')return void(async()=>{const novo=await uiPrompt({eyebrow:'Ambiente',title:'Renomear ambiente',label:'Novo nome',placeholder:ambiente,confirmLabel:'Renomear'});if(novo)renomearPedidoAmbiente(ambiente,novo);})();
  if(acao==='duplicar-ambiente')return duplicarPedAmbiente(ambiente);
  if(acao==='remover-ambiente')return removerPedidoAmbiente(ambiente);
  if(acao==='nova-peca')return addPedidoItem(_pedAmbAtivo||ambiente||'');
  if(acao==='duplicar-peca')return duplicarPedItem(pecaIndex);
  if(acao==='excluir-peca')return excluirPecaAtiva(pecaIndex);
}
function abrirSeletorMaterial(i){
  _pedItemAtivo=i;
  openModal('modal-selecionar-material');
  const busca=document.getElementById('orc-mat-busca');if(busca)busca.value='';
  renderOrcMateriaisModal();
}
function renderOrcMateriaisModal(){
  const el=document.getElementById('orc-materiais-lista');if(!el)return;
  const q=(document.getElementById('orc-mat-busca')?.value||'').toLowerCase().trim();
  const lista=(CACHE.pedras||DB.get('pedras')||[]).filter(p=>!q||String(p.nome||'').toLowerCase().includes(q)||String(p.tipo||'').toLowerCase().includes(q));
  if(!lista.length){el.innerHTML='<div class="orc-panel-empty">Nenhum material corresponde à busca.</div>';return;}
  el.innerHTML=lista.map(p=>{
    const preco=precoMaterialEstimado(p.nome);
    const image=window.MaterialImageLibrary?.defaultImage(p,DB.get('estoque'),refImagemPedra(p));
    return `<div class="orc-piece-card" style="cursor:pointer" onclick='escolherMaterialPeca(${JSON.stringify(p.nome||'')})'>
      <div class="orc-material-thumb" id="orc-material-select-${escapeHtml(p.id)}"><i class="ti ti-photo"></i></div>
      <div class="orc-piece-info">
        <div style="font-weight:700;font-size:13px">${escapeHtml(p.nome||'')}</div>
        <div style="font-size:11.5px;color:var(--muted)">${escapeHtml(p.tipo||'')} ${image?'· '+escapeHtml(window.MaterialImageLibrary.IMAGE_TYPES[image.type]?.label||'Imagem verificada'):''}</div>
        <div class="orc-piece-actions">
          <span class="orc-piece-total">${preco.valor?fmt(preco.valor)+'/m²':''}</span>
          <button type="button" class="btn btn-ghost btn-sm" onclick="event.stopPropagation();abrirMaterialView('${escapeHtml(p.id)}','${escapeHtml(image?.id||'')}')">Visualizar</button>
        </div>
      </div>
    </div>`;
  }).join('');
  lista.forEach(async p=>{
    const image=window.MaterialImageLibrary?.defaultImage(p,DB.get('estoque'),refImagemPedra(p));if(!image)return;
    const url=await materialImageDisplayUrl(image),thumb=document.getElementById(`orc-material-select-${p.id}`);
    if(url&&thumb)thumb.innerHTML=`<img src="${escapeHtml(url)}" alt="${escapeHtml(p.nome||'Material')}" loading="lazy" decoding="async">`;
  });
}
function escolherMaterialPeca(nome){
  if(_pedItemAtivo==null)return;
  aplicarCatalogoItem(_pedItemAtivo,nome);
  closeModal('modal-selecionar-material');
}

